import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const accessibility = otto.ally ?? {};
const srSpeak = accessibility.srSpeak;
export {
  accessibility,
  srSpeak
};
/*                                            */
